export default __webpack_public_path__ + "static/media/frame-grandchief.59964868.png";